import { Product } from "@/types/product";
import { TFunction } from "i18next";
import * as XLSX from 'xlsx';

export interface ParsedProQty {
  productCode: string;
  count: number;
  matchPurTemQty: number;
  matchInvTemQty: number;
  product?: Product
}

/**
 * 获取单元格值并trim
 */
const getCellValue = (row: any[], index: number): string => {
  if (row[index] === undefined || row[index] === null) return '';
  return String(row[index]).trim();
};
//解析表格
export const parseData = (file: File, t: TFunction): Promise<ParsedProQty[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // 解析为二维数组
        const jsonData = XLSX.utils.sheet_to_json<string[]>(worksheet, { header: 1 });

        if (!jsonData || jsonData.length === 0) {
          reject(new Error('invalid'));
          return;
        }

        // 解析数据行（跳过表头）
        const result: ParsedProQty[] = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (!row || row.length === 0) continue;
          let code = getCellValue(row, 0);
          let qty = Number(getCellValue(row, 3));

          // 检查是否已存在相同 code 的记录
          const existingIndex = result.findIndex(item => item.productCode === code);
          if (existingIndex !== -1) {
            // 存在则累加数量
            result[existingIndex].count += qty;
            result[existingIndex].matchPurTemQty += qty;
            result[existingIndex].matchInvTemQty += qty;
          } else {
            // 不存在则 push
            result.push({
              productCode: code,
              count: qty,
              matchPurTemQty: qty,
              matchInvTemQty: qty,
            });
          }
        }

        resolve(result.filter(item => !!item.productCode && !!item.count));
      } catch {
        reject(new Error('invalid'));
      }
    };
    reader.onerror = () => reject(new Error('invalid'));
    reader.readAsArrayBuffer(file);
  });
};